{
	"title": "Pagina's",
	"description": "Over ons, retourneren, voorwaarden: de vaste pagina's van de shop.",
	"searchLabel": "Zoek op titel of slug",
	"empty": "Er zijn nog geen pagina's.",
	"column": {
		"title": "Titel",
		"slug": "Slug",
		"status": "Status",
		"updated": "Laatst opgeslagen"
	},
	"new": {
		"title": "Pagina toevoegen",
		"description": "Een nieuwe pagina is pas in de shop te zien als je hem publiceert.",
		"submit": "Toevoegen"
	},
	"edit": {
		"submit": "Opslaan"
	},
	"field": {
		"title": "Titel",
		"slug": "Slug",
		"slugDescription": "Het adres van de pagina: kleine letters, cijfers en streepjes. Volgt de titel tot je hem zelf aanpast.",
		"slugReset": "Weer laten volgen",
		"body": "Tekst",
		"bodyDescription": "In markdown: ## kop, **vet**, *schuin*, - opsomming, [link](https://…).",
		"preview": "Voorbeeld",
		"previewEmpty": "Typ een tekst om het voorbeeld te zien.",
		"seo": "Zoekmachines",
		"seoDescriptionHelp": "Hoe de pagina in Google verschijnt. Leeg laten mag: dan gebruikt de shop de titel.",
		"seoTitle": "SEO-titel",
		"seoDescription": "SEO-omschrijving",
		"length": "{{count}} van ongeveer {{advised}} tekens",
		"tooLong": "{{count}} tekens: langer dan {{advised}} wordt in Google meestal afgekapt",
		"published": "Gepubliceerd",
		"publishedDescription": "Aan: de pagina staat in de shop. Uit: alleen jij ziet hem hier."
	},
	"slugTaken": "Er is al een pagina met deze slug.",
	"changed": "Iemand anders heeft deze pagina intussen opgeslagen. Laad de pagina opnieuw; je wijzigingen gaan dan verloren.",
	"reload": "Opnieuw laden",
	"delete": {
		"button": "Verwijderen",
		"title": "Pagina verwijderen?",
		"description": "\"{{title}}\" verdwijnt uit het beheer en uit de shop. Dit kun je niet ongedaan maken.",
		"confirm": "Verwijderen"
	},
	"help": {
		"pages": {
			"title": "Pagina's",
			"area": "Content › Pagina's",
			"short": "De vaste pagina's van de shop, zoals Over ons, Verzenden en retourneren en de voorwaarden. Een pagina staat op cleanbudget.nl/ met zijn slug erachter, in de leesopmaak van de shop.",
			"terms": ["page:page", "page:slug", "page:published"]
		},
		"page": {
			"title": "Pagina",
			"area": "Content › Pagina's",
			"short": "Een pagina heeft een titel, een slug en een tekst in markdown, en zo nodig eigen teksten voor zoekmachines. In de shop staat hij pas als Gepubliceerd aan staat: tot dan zie je hem alleen in het beheer.",
			"terms": ["page:title", "page:slug", "page:markdown", "page:seo", "page:published"]
		},
		"title": {
			"title": "Titel",
			"area": "Content › Pagina's › Pagina",
			"short": "De grote kop boven de pagina in de shop. Laat je de SEO-titel leeg, dan is dit ook de titel in Google en in het tabblad van de browser.",
			"terms": ["page:seo"]
		},
		"slug": {
			"title": "Slug",
			"area": "Content › Pagina's › Pagina",
			"short": "Het laatste stuk van het adres van de pagina in de shop: cleanbudget.nl/over-ons. Twee pagina's kunnen niet dezelfde slug hebben.",
			"warning": "De shop linkt zelf naar over-ons, verzenden-en-retourneren, algemene-voorwaarden, herroeping, privacy en cookies: wijzig je zo'n slug, dan komt een klant via die link op een foutpagina. Bij zakelijk en contact verdwijnt dan de tekst boven het formulier."
		},
		"markdown": {
			"title": "Markdown",
			"area": "Content › Pagina's › Pagina",
			"short": "Je typt de tekst gewoon, met een paar tekens voor de opmaak. De shop maakt er koppen, lijsten, vet en links van, in zijn eigen letter. HTML toont de shop als gewone tekst.",
			"choices": [
				{
					"name": "## Kop",
					"text": "Een tussenkop, op een eigen regel."
				},
				{
					"name": "- punt",
					"text": "Een opsomming: elke regel met een streepje is een punt. Met 1. ervoor wordt de lijst genummerd."
				},
				{
					"name": "**vet** en *schuin*",
					"text": "Vet of schuin, midden in een zin."
				},
				{
					"name": "[tekst](https://…)",
					"text": "Een link. Naar een pagina van de shop mag kort: [Retourneren](/verzenden-en-retourneren)."
				},
				{
					"name": "Lege regel",
					"text": "Een nieuwe alinea. Eén enter zonder lege regel blijft dezelfde alinea."
				}
			],
			"warning": "Gebruik ## voor een kop, niet #: de titel is al de hoofdkop van de pagina.",
			"terms": ["faqItem:answer"]
		},
		"seo": {
			"title": "Zoekmachines",
			"area": "Content › Pagina's › Pagina",
			"short": "Wat Google bij de pagina toont: de SEO-titel als de blauwe regel, de SEO-omschrijving eronder. Laat je ze leeg, dan neemt de shop de titel van de pagina en zijn eigen omschrijving van de shop.",
			"terms": ["page:title"]
		},
		"published": {
			"title": "Gepubliceerd",
			"area": "Content › Pagina's › Pagina",
			"short": "Aan: de pagina staat in de shop. Uit: je ziet hem alleen in het beheer, en zijn adres geeft in de shop een foutpagina. Zo schrijf je rustig aan een nieuwe pagina.",
			"warning": "Zet je een pagina uit waar de shop zelf naar linkt, zoals Over ons, dan komt een klant via die link op een foutpagina.",
			"terms": ["page:slug"]
		}
	},
	"helpExample": {
		"page": {
			"label": "Een pagina in de shop: de titel Retourneren, wanneer hij is bijgewerkt, een alinea, de kop Binnen 30 dagen en een lijst van drie stappen.",
			"title": "Retourneren",
			"body": "Past het niet? Stuur het gerust terug.\n\n## Binnen 30 dagen\n\n- Pak het in de doos waarin het kwam.\n- Plak het **retourlabel** erop.\n- Breng het naar een PostNL-punt.\n\nMeer weten? Lees de [veelgestelde vragen](/veelgestelde-vragen).",
			"updated": "2026-11-01"
		},
		"markdown": {
			"sandbox": "Pas de tekst aan en zie hoe de shop hem toont.",
			"source": "Tekst in markdown",
			"shopLabel": "De tekst zoals de shop hem toont: {{text}}",
			"animation": "Animatie: je typt een kop met ## en een lijst met streepjes, slaat op, en in de shop staat een kop met een lijst eronder.",
			"steps": {
				"heading": "Typ ## en een spatie voor een kop.",
				"list": "Typ een streepje en een spatie voor elk punt.",
				"save": "Zet Gepubliceerd aan en sla op.",
				"shop": "In de shop staat een kop met een lijst eronder."
			},
			"heading": "Binnen 30 dagen",
			"firstItem": "Pak het in.",
			"secondItem": "Plak het label erop."
		}
	}
}
